import trMessages from "./messages/tr_TR.json";
import azMessages from "./messages/az.json";

const messages = {
  az: azMessages,
  "tr-tr": trMessages
};

export default messages;

